module.exports = "/_next/static/images/contentMarketingImage-30700f560a3d51c50cc564ab72338d22.jpg.webp";